import React, { useEffect, useState } from "react";
import Shell from "@/components/Shell";
import api from "@/lib/api";
import { toast } from "sonner";

const MatchesPage = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/matches");
        setMatches(res.data);
      } catch (err) {
        toast.error(err?.response?.data?.detail || "Failed to load");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Shell title="Your Matches">
      <p className="text-sm text-slate-600 mb-8">
        Confirmed mutual interest only. Reach out and start a conversation.
      </p>

      {loading ? (
        <div className="overline">Loading…</div>
      ) : matches.length === 0 ? (
        <div className="text-center py-16">
          <div className="mm-divider-gold mx-auto" />
          <div className="overline mb-2 mt-4">No matches yet</div>
          <p className="text-sm text-slate-600">
            Matches appear once both attendees confirm interest.
          </p>
        </div>
      ) : (
        <div className="flex flex-col gap-4" data-testid="matches-list">
          {matches.map((m) => (
            <div
              key={m.id}
              data-testid={`match-card-${m.id}`}
              className="bg-white border border-slate-200 rounded-sm p-6"
            >
              <div className="font-serif-display text-2xl">{m.first_name}</div>
              <div className="mm-divider-gold" />
              <div className="text-sm text-slate-600">{m.occupation}</div>
              <div className="overline mt-2">Age {m.age}</div>
              {m.email && (
                <a
                  href={`mailto:${m.email}`}
                  className="overline mt-4 inline-block hover:underline"
                  style={{ color: "#0F172A" }}
                  data-testid={`match-email-${m.id}`}
                >
                  {m.email} →
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </Shell>
  );
};

export default MatchesPage;
